import {RestClient} from "zavadil-ts-common";
import {Role} from "../../types/UserRole";

export class RolesClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	all(): Promise<Array<Role>> {
		return this.client.getJson('role/all');
	}

}
